import { render, staticRenderFns } from "./projectChannelPage.vue?vue&type=template&id=71eac930&scoped=true"
import script from "./projectChannelPage.vue?vue&type=script&lang=js"
export * from "./projectChannelPage.vue?vue&type=script&lang=js"
import style0 from "./projectChannelPage.vue?vue&type=style&index=0&id=71eac930&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eac930",
  null
  
)

export default component.exports